// --- Popup dismissed cookie ---
var PU_DISMISSED_COOKIE = "pu_dismissed";

function setPuDismissedCookie() {
  var expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie =
    PU_DISMISSED_COOKIE +
    "=1; expires=" +
    expires.toUTCString() +
    "; path=/; SameSite=Lax";
}

function isPuDismissed() {
  return false;
}

function triggerDecline($puOuter) {
  if (!$puOuter || !$puOuter.hasClass("is-open")) return;
  var productId = $puOuter.attr("data-product-id");
  trackToSheets("Popups_acceptance_v2", {
    event: "Upsell_declined",
    product_id: productId,
    timestamp: new Date().toISOString(),
  });
  setPuDismissedCookie();
  setDeclinedCartAttribute();
  $puOuter.removeClass("is-open");
  $("body").css("overflow", "");
  setTimeout(function () {
    $puOuter.css("display", "none");
    if (window.sendTrackingEvent) sendTrackingEvent("going_to_checkout");
    window.location.href = "/checkout";
  }, 300);
}

function setDeclinedCartAttribute() {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ attributes: { popupUpsellDeclined: "true" } }),
    keepalive: true,
  });
}

// --- Google Sheets tracking ---
var SHEETS_WEBHOOK_URL =
  "https://script.google.com/macros/s/AKfycbya5eWKkDX7zQpSzFIG236Q4TOG_5CSAnXax2XnxJYGWDuwyd9PYvgpYI_61htglum0/exec";

function trackToSheets(sheetName, rowData) {
  if (!SHEETS_WEBHOOK_URL || SHEETS_WEBHOOK_URL.indexOf("YOUR_") === 0) return;
  rowData.url = window.location.href;
  var payload = JSON.stringify({ sheet: sheetName, row: rowData });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(
      SHEETS_WEBHOOK_URL,
      new Blob([payload], { type: "text/plain" }),
    );
  } else {
    fetch(SHEETS_WEBHOOK_URL, {
      method: "POST",
      mode: "no-cors",
      body: payload,
    });
  }
}

// --- Orphaned upsell removal ---
// Upsell items (LASTTIME property) cannot exist alone in cart — remove them if no regular items remain
function removeOrphanedUpsells() {
  $.getJSON("/cart.js", function (cart) {
    if (cart.items.length === 0) return;

    var upsellItems = cart.items.filter(function (item) {
      return item.properties && item.properties._LASTTIME;
    });
    var regularItems = cart.items.filter(function (item) {
      return !item.properties || !item.properties._LASTTIME;
    });

    if (upsellItems.length > 0 && regularItems.length === 0) {
      var updates = {};
      upsellItems.forEach(function (item) {
        updates[item.key] = 0;
      });
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: JSON.stringify({ updates: updates }),
        contentType: "application/json",
        success: function () {
          if (window.refreshCartDrawer) {
            window.refreshCartDrawer(true, null);
          }
        },
      });
    }
  });
}

// --- Per-popup JS trigger flag ---
// A popup with data-js-flag only shows when that window variable is truthy.
// A popup with no flag (e.g. the tint offer) always shows.
function isPopupEnabled($popup) {
  var flag = $popup.attr("data-js-flag");
  if (!flag) return true;
  return !!window[flag];
}

// --- Popup countdown timer ---
var _popupTimerInterval = null;

function startPopupTimer(puOuterEl) {
  if (_popupTimerInterval) {
    clearInterval(_popupTimerInterval);
    _popupTimerInterval = null;
  }

  var totalSeconds = 5 * 60;
  var $timer = $(puOuterEl).find(".pu_announcment-timer");

  function formatTime(s) {
    var m = Math.floor(s / 60);
    var sec = s % 60;
    return (m < 10 ? "0" : "") + m + ":" + (sec < 10 ? "0" : "") + sec;
  }

  $timer.text(formatTime(totalSeconds));

  _popupTimerInterval = setInterval(function () {
    totalSeconds -= 1;
    if (totalSeconds < 0) totalSeconds = 0;
    $timer.text(formatTime(totalSeconds));
    if (totalSeconds === 0) {
      clearInterval(_popupTimerInterval);
      _popupTimerInterval = null;
    }
  }, 1000);
}

function stopPopupTimer() {
  if (_popupTimerInterval) {
    clearInterval(_popupTimerInterval);
    _popupTimerInterval = null;
  }
}

$(document).ready(function () {
  // Run on page load in case cart already has orphaned upsells
  removeOrphanedUpsells();

  // Hook into refreshCartDrawer so every cart update triggers the check
  setTimeout(function () {
    var _orig = window.refreshCartDrawer;
    if (_orig) {
      window.refreshCartDrawer = function () {
        var result = _orig.apply(this, arguments);
        setTimeout(removeOrphanedUpsells, 600);
        return result;
      };
    }
  }, 0);

  // --- Shade selector (scoped to each popup) ---
  $(document).on("click", ".pu_outer .simple-product_shade", function () {
    var $shade = $(this);
    var $puOuter = $shade.closest(".pu_outer");
    var variantId = $shade.attr("data-id");
    var variantTitle = $shade.attr("data-title");

    $puOuter.find(".simple-product_shade").removeClass("active");
    $shade.addClass("active");

    $puOuter.find(".simple-product_shades_info__js").html(variantTitle);

    $puOuter.find(".pu_main-img-src").addClass("hided");
    $puOuter
      .find('.pu_main-img-src[data-id="' + variantId + '"]')
      .removeClass("hided");

    $puOuter.find(".pu_price").addClass("hided");
    $puOuter
      .find('.pu_price[data-id="' + variantId + '"]')
      .removeClass("hided");
  });

  // --- Checkout button intercept ---
  $(document).on("click", ".cd_checkoutbnt", function (e) {
    e.preventDefault();

    $.ajax({
      url: "/cart.js",
      dataType: "json",
      timeout: 2000,
      error: function () {
        trackToSheets("Popup_visibility_v2", {
          event: "Popup_error",
          timestamp: new Date().toISOString(),
        });
        window.location.href = "/checkout";
      },
      success: function (cart) {
        var hasOffer = cart.items.some(function (item) {
          return item.properties && item.properties._LASTTIME;
        });

        if (
          hasOffer ||
          cart.items.length === 0 ||
          $(".pu_outer").length === 0 ||
          isPuDismissed()
        ) {
          trackToSheets("Popup_visibility_v2", {
            event: "Popup_no",
            timestamp: new Date().toISOString(),
          });
          if (window.sendTrackingEvent) sendTrackingEvent("theme_caught_click");
          if (window.sendTrackingEvent) sendTrackingEvent("going_to_checkout");
          window.location.href = "/checkout";
          return;
        }

        var cartProductIds = cart.items.map(function (item) {
          return String(item.product_id);
        });

        var $matchingPopup = null;
        $(".pu_outer:not([data-fallback='true'])").each(function () {
          var $popup = $(this);
          if (!isPopupEnabled($popup)) return;
          var triggerId = $popup.attr("data-trigger-id");
          if (triggerId && cartProductIds.indexOf(triggerId) !== -1) {
            $matchingPopup = $popup;
            return false;
          }
        });

        var $fallbackPopup = $(".pu_outer[data-fallback='true']").filter(
          function () {
            return isPopupEnabled($(this));
          },
        );
        var $popupToShow =
          $matchingPopup && $matchingPopup.length
            ? $matchingPopup
            : $fallbackPopup;

        if ($popupToShow && $popupToShow.length) {
          var popupProductId = $popupToShow.attr("data-product-id");
          $popupToShow.css("display", "flex");
          $("body").css("overflow", "hidden");
          requestAnimationFrame(function () {
            $popupToShow.addClass("is-open");
            trackToSheets("Popup_visibility_v2", {
              event: "Popup_show",
              product_id: popupProductId,
              timestamp: new Date().toISOString(),
            });
            if (window.sendTrackingEvent)
              sendTrackingEvent("theme_caught_click");
          });
        } else {
          trackToSheets("Popup_visibility_v2", {
            event: "Popup_no",
            timestamp: new Date().toISOString(),
          });
          if (window.sendTrackingEvent) sendTrackingEvent("theme_caught_click");
          if (window.sendTrackingEvent) sendTrackingEvent("going_to_checkout");
          window.location.href = "/checkout";
        }
      },
    });
  });

  // --- Decline: close popup and go to checkout ---

  $(document).on("click", ".pu_inner-close", function () {
    triggerDecline($(this).closest(".pu_outer"));
  });

  $(document).on("click", ".pu_decline-btn", function () {
    triggerDecline($(this).closest(".pu_outer"));
  });

  // --- Decline on click outside popup ---
  $(document).on("click", ".pu_outer", function (e) {
    if (!$(e.target).closest(".pu_inner").length) {
      triggerDecline($(this));
    }
  });

  // --- Decline on ESC key ---
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      triggerDecline($(".pu_outer.is-open").first());
    }
  });

  // --- Accept: add upsell with OFFER: 35% property, then checkout ---
  $(document).on("click", ".pu_accept-btn", function () {
    $(this).addClass("loading");
    var $puOuter = $(this).closest(".pu_outer");
    var discountNeeded = $(this).attr("data-discount");
    var productId = $puOuter.attr("data-product-id");
    var acceptClickedAt = Date.now();
    var variantId = $puOuter
      .find(".simple-product_shade.active")
      .attr("data-id");

    if (!variantId) {
      variantId = $puOuter.find(".pu_main-img-src").first().attr("data-id");
    }

    if (!variantId) return;

    trackToSheets("Popups_acceptance_v2", {
      event: "Upsell_accepted",
      product_id: productId,
      variant_id: variantId,
      timestamp: new Date().toISOString(),
    });

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1,
        properties: {
          _SALEOFFER: "" + discountNeeded + "%",
          _LASTTIME: "BRUSH OFFER",
        },
      }),
      contentType: "application/json",
      success: function () {
        var duration_ms = Date.now() - acceptClickedAt;
        trackToSheets("Popup_timing_v2", {
          product_id: productId,
          variant_id: variantId,
          duration_ms: duration_ms,
          timestamp: new Date().toISOString(),
        });
        $(".pu_accept-btn").removeClass("loading");
        $(".pu_outer").removeClass("is-open");
        $("body").css("overflow", "");
        setTimeout(function () {
          $(".pu_outer").css("display", "none");
          if (window.sendTrackingEvent) sendTrackingEvent("going_to_checkout");
          window.location.href = "/checkout";
        }, 300);
      },
      error: function () {
        $(".pu_accept-btn").removeClass("loading").addClass("error");
        $(".pu_outer").removeClass("is-open");
        $("body").css("overflow", "");
        $(".pu_outer").css("display", "none");
      },
    });
  });

  // --- MutationObserver: start/stop timer whenever is-open is toggled on any .pu_outer ---
  document.querySelectorAll(".pu_outer").forEach(function (el) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var hadIsOpen = mutation.oldValue
          ? mutation.oldValue.split(" ").indexOf("is-open") !== -1
          : false;
        var hasIsOpen = el.classList.contains("is-open");
        if (hasIsOpen && !hadIsOpen) {
          startPopupTimer(el);
        } else if (!hasIsOpen && hadIsOpen) {
          stopPopupTimer();
        }
      });
    }).observe(el, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"],
    });
  });
});
